import {Box, Skeleton, SkeletonProps, Stack, useTheme} from '@mui/material';
import {useAppContext} from '../../../contexts/app/context';
import {ThemeMode} from '../../../enums/theme-mode';

const SKELETON_DEFAULT_PROPS = {
  animation: 'wave',
  variant: 'rounded',
} as SkeletonProps;

export const ActivitySkeleton = () => {
  const theme = useTheme();

  const AppContext = useAppContext();

  return (
    <Box
      sx={{
        flex: 1,
        padding: '16px',
        width: '100%',
        minHeight: '400px',
        flexGrow: 0,
        boxShadow: '0px 4px 16px rgba(29, 41, 57, 0.15)',
        borderRadius: '5px',
        backgroundColor:
          AppContext.state.currentThemeMode === ThemeMode.Light
            ? theme.palette.background.paper
            : theme.palette.grey[900],
      }}
    >
      <Stack
        sx={{
          display: 'flex',
          flexDirection: {xs: 'column', lg: 'row'},
          gap: '60px',
        }}
      >
        <Stack gap={2} maxWidth="300px">
          <Stack gap={2}>
            <Stack sx={{display: 'flex', flexDirection: 'row', alignItems: 'center'}} gap={2}>
              <Skeleton {...SKELETON_DEFAULT_PROPS} width={32} height={32} />
              <Skeleton {...SKELETON_DEFAULT_PROPS} width={140} height={20} />
              <Skeleton {...SKELETON_DEFAULT_PROPS} width={60} height={20} />
            </Stack>
          </Stack>
          <Stack
            gap={4}
            sx={{display: 'flex', flexWrap: 'wrap', flexDirection: 'row', paddingTop: '30px'}}
          >
            <Stack gap={2} width={{xs: '100px', lg: '120px'}}>
              <Skeleton {...SKELETON_DEFAULT_PROPS} width={70} height={20} />
              <Skeleton {...SKELETON_DEFAULT_PROPS} width={120} height={20} />
            </Stack>
            <Stack gap={2} width={{xs: '80px', lg: '120px'}}>
              <Skeleton {...SKELETON_DEFAULT_PROPS} width={70} height={20} />
              <Skeleton {...SKELETON_DEFAULT_PROPS} width={120} height={20} />
            </Stack>
            <Stack gap={2} width={{xs: '80px', lg: '120px'}}>
              <Skeleton {...SKELETON_DEFAULT_PROPS} width={70} height={20} />
              <Skeleton {...SKELETON_DEFAULT_PROPS} width={120} height={20} />
            </Stack>
            <Stack gap={2} width={{xs: '80px', lg: '120px'}}>
              <Skeleton {...SKELETON_DEFAULT_PROPS} width={70} height={20} />
              <Skeleton {...SKELETON_DEFAULT_PROPS} width={120} height={20} />
            </Stack>
          </Stack>
        </Stack>
        <Stack gap={2}>
          <Stack gap={2}>
            <Skeleton {...SKELETON_DEFAULT_PROPS} width={210} height={20} />
            <Skeleton {...SKELETON_DEFAULT_PROPS} width={300} height={20} />
          </Stack>
          <Stack gap={2}>
            <Skeleton {...SKELETON_DEFAULT_PROPS} width={190} height={60} />
            <Skeleton {...SKELETON_DEFAULT_PROPS} width={190} height={60} />
            <Skeleton {...SKELETON_DEFAULT_PROPS} width={190} height={60} />
          </Stack>
        </Stack>
        <Stack gap={2}>
          <Stack gap={2}>
            <Skeleton {...SKELETON_DEFAULT_PROPS} width={210} height={20} />
            <Skeleton {...SKELETON_DEFAULT_PROPS} width={300} height={20} />
          </Stack>
          <Stack gap={2}>
            <Skeleton {...SKELETON_DEFAULT_PROPS} width={190} height={60} />
            <Skeleton {...SKELETON_DEFAULT_PROPS} width={190} height={60} />
          </Stack>
        </Stack>
      </Stack>
    </Box>
  );
};
